const StrangeAuth = require("strange-auth");
const WebClient = require("utils/web-client");
const History = require("wiring/history");
const AuthTypes = require("action-types/auth");
const SnackbarActions = require("../actions/snackbar");
const GTMCustom = require("../utils/gtm-custom");

const internals = {};

const actions = exports;

exports.fetchUserDataBegin = () => {
    return {
        type: AuthTypes.USER_FETCH_BEGIN
    };
};

exports.fetchUserDataSuccess = user => {
    return {
        type: AuthTypes.USER_FETCH_SUCCESS,
        payload: { user }
    };
};

exports.fetchUserDataFail = () => {
    return {
        type: AuthTypes.USER_FETCH_FAIL
    };
};

exports.fetchUserData = () => {
    return dispatch => {
        dispatch(actions.fetchUserDataBegin());

        const getUser = WebClient.get("/user");

        getUser
            .then(({ data }) => {
                dispatch(actions.fetchUserDataSuccess(data));
            })
            .catch(error => {
                dispatch(SnackbarActions.messageSnackbar(error.message));
            });

        return getUser;
    };
};

exports.validateAuth = () => {
    return (dispatch, getState) => {
        const { auth } = getState();
        const token = (auth.credentials && auth.credentials.token) || null;

        // No token was rehydrated into state from localStorage
        // Therefore, user is definitely not authenticated, no
        // need to change auth, as it should be initial state
        if (!token) {
            // Defensively logout, mark user's state as explicitly unauthenticated...not totally sure if necessary
            return dispatch(internals.strangeActions.logout());
        }

        const getUser = WebClient.get("/user");
        getUser
            .then(({ data }) => {
                // Designed to match return of of our login strangeaction
                // Mostly redundant with the data redux-persist rehydrates
                // But refreshes the associated user data, ensuring that a user's
                // browser can't hold onto an snapshot of their account data that's
                // out of sync with the backing database
                dispatch(
                    internals.strangeActions.loginSuccess({
                        credentials: { token, user: data }
                    })
                );
            })
            // We primarily intend to catch 401s (Unauthorized) from the API
            // Signifying that the authenticating user's token is somehow invalid
            // and they need to re-login
            .catch(() => dispatch(internals.strangeActions.logout()));
    };
};

exports.registrationBegin = () => {
    return {
        type: AuthTypes.REGISTRATION_BEGIN
    };
};

exports.registrationSuccess = () => {
    return {
        type: AuthTypes.REGISTRATION_SUCCESS
    };
};

exports.registrationFail = () => {
    return {
        type: AuthTypes.REGISTRATION_FAIL
    };
};

exports.updateEmailBegin = () => {
    return {
        type: AuthTypes.UPDATE_EMAIL_BEGIN
    };
};

exports.updateEmailSuccess = email => {
    return {
        type: AuthTypes.UPDATE_EMAIL_SUCCESS,
        payload: { email }
    };
};

exports.updateEmailFail = () => {
    return {
        type: AuthTypes.UPDATE_EMAIL_FAIL
    };
};

exports.registerUser = (email, firstName, lastName, password, redirect) => {
    return dispatch => {
        dispatch(actions.registrationBegin());

        const newUser = WebClient.post("/users", {
            email,
            firstName,
            lastName,
            password
        });

        newUser
            .then(({ data }) => {
                dispatch(SnackbarActions.messageSnackbar("Signup successful!"));
                dispatch(actions.registrationSuccess());
                dispatch(actions.login(email, password, redirect));

                GTMCustom.event("newUser", data.id);
            })
            .catch(err => {
                const errMessage =
                    typeof err.response !== "undefined"
                        ? err.response.data.message
                        : "Signup failed. Please try again.";

                dispatch(SnackbarActions.messageSnackbar(errMessage));
                dispatch(actions.registrationFail());
            });

        return newUser;
    };
};

exports.updateUserEmail = email => {
    return dispatch => {
        dispatch(actions.updateEmailBegin());

        const updateUser = WebClient.patch("/user", { email });

        updateUser
            .then(({ data }) => {
                dispatch(actions.updateEmailSuccess(email));
                dispatch(
                    SnackbarActions.messageSnackbar("Your email has changed!")
                );
            })
            .catch(err => {
                const errMessage =
                    typeof err.response !== "undefined"
                        ? err.response.data.message
                        : "An error has occured. Please try again.";

                dispatch(SnackbarActions.messageSnackbar(errMessage));
                dispatch(actions.updateEmailFail());
            });

        return updateUser;
    };
};

exports.login = (email, password, redirect) => {
    return dispatch => {
        const strangeLogin = internals.strangeActions.login(email, password);

        return dispatch(strangeLogin)
            .then(() => {
                if (redirect) {
                    History.replace(redirect);
                } else {
                    History.push("/portfolio");
                }
            })
            .catch(err => {
                const errMessage =
                    typeof err.response !== "undefined"
                        ? err.response.data.message
                        : "Login failed. Please try again.";

                dispatch(SnackbarActions.messageSnackbar(errMessage));
            });
    };
};

exports.logout = () => {
    return dispatch => {
        dispatch(internals.strangeActions.logout());
        return History.push("/");
    };
};

internals.strangeActions = StrangeAuth.makeActions({
    login: (email, password) => {
        let token;

        return WebClient.post(
            "/login",
            { email, password },
            { responseType: "text" }
        )
            .then(({ data, status }) => {
                if (status !== 200) {
                    const err = new Error("Bad login");
                    err.info = data;
                    return Promise.reject(err);
                }

                token = data;

                return WebClient.get("/user", {
                    headers: { authorization: `Bearer ${token}` }
                });
            })
            .then(({ data, status }) => {
                if (status !== 200) {
                    const err = new Error("Bad login");
                    err.info = data;
                    return Promise.reject(err);
                }

                return {
                    credentials: {
                        token,
                        user: data
                    }
                };
            });
    }
});



// WEBPACK FOOTER //
// ./src/actions/auth.js